module.exports = __webpack_public_path__ + "static/media/brl-logo.e7b2bccc.png";